import { ReportingSortingDirection } from "@/pages/reporting_v2/types";

type Props = {
  isActive?: boolean;
  direction?: ReportingSortingDirection;
};

export const ReportingSortIndicator: React.FC<Props> = ({
  isActive,
  direction,
}) =>
  isActive ? (
    <span className="ml-[4px] text-[9px]">
      {direction === ReportingSortingDirection.DESC ? "▼" : "▲"}
    </span>
  ) : (
    <span className="ml-[4px] text-[9px] text-[#C7C0C0]">↕</span>
  );
